import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { History } from '../../models/history';
import { withHistorySelectors } from './history.selectors';
import { HistoryService } from '../../services/history/history.service';

export type HistoryState = BaseState<History>;

export const initialState: HistoryState = {
  items: {},
  loading: false,
  initialized: false,
  itemsLoaded: false,
  selectedId: '',
  selection: [],
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'History',
  entityLabel: 'Verlauf',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const HistoryStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<History>(HistoryService),
  withHistorySelectors(),
  withMethods(store => ({})),
  withHooks({
    onInit({ loadAllItemsByPromise }) {
      loadAllItemsByPromise();
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
